<div class="container__filter" (click)="closedSearch()">
  <!-- BUSCA SUPERIOR -->
  <div class="dnd-filter">
    <div class='dnd-element'>
      <div class="dnd-itens-filter">
        <app-autocomplete placeholder="Editar"
        inputId="distribution-broker-search-1"
        placeholder="Busca"
        maxLength="200"
        [autoSearchResults]="options" 
        [onlyDescription]="!featureInputSearch"
        (ElementSelected)="elementSelected($event)"
        (autocompleteSearch)="searchElement($event)"
        value="description"
        [enhanveOnHover]="false">
        </app-autocomplete>
      </div>
      <div class="dnd-itens-filter">
        <button id="dnd-filter-btn" class="btn-filter rounded__border" (click)="handleModal()">
          <img src="../../assets/svgs/funnel.svg" alt="Funnel Inativo" *ngIf="!hasFilter">
          <img src="../../assets/svgs/funnel_act.svg" alt="Funnel Ativo" *ngIf="hasFilter">
        </button>
        <img class="dnd-dot-alert" src="../../assets/svgs/dot-alert.svg" alt="Alert" *ngIf="validator()">
      </div>
    </div>
  </div>

  <div *ngIf="modal2 && !showFacModal"  class="expanded-modal" [ngClass]="{'display-none': !modal2}">
    <div class="filter-content-modal rounded__border">
      <div class="content-scrollable">
        <div class="header-modal">
          <div class="filter-title">{{titleLeadsModal}}</div>
          <img class="cursor__pointer" src="../../../../assets/svgs/close_btn.svg" alt="close" (click)="closeLeadsByBroker()">
        </div>
        <div class="custom__table__leads">
          <table class="rounded__border table__border scroll__customized">
            <div class="table__content--full-width">
              <tr class="header row__modal__table">
                <th *ngFor="let column of selectedLeadsHeaders; let i = index"
                  [ngStyle]="column.style.headerWidth ? {'min-width': column.style.headerWidth, 'width': column.style.headerWidth} : {'min-width': column.style.width, 'width': column.style.width}">
                  <app-arrow-label *ngIf="column.sort" (sort)="sort($event, column)" label="column.label">
                    <span>{{column.label}}</span>
                  </app-arrow-label>
                  <span *ngIf="!column.sort">{{column.label}}</span>
                </th>
              </tr>
              <div style="width: 100%;">
                <tbody class="body">
                  <tr *ngFor="let bodyItem of dataSelected; let i = index" class="row__modal__table">
                    <td [ngStyle]="{'min-width': column.style.width, 'width': column.style.width}" [ngClass]="{'text__dotted': column.dotted}"
                      (click)="column.onClick && column.onClick(bodyItem, bodyItem[column.id])"
                      *ngFor="let column of selectedLeadsHeaders; let i = index">
                      <app-contact-component [item]="bodyItem[column.id]" *ngIf="column.contact"></app-contact-component>
                      <app-avatar-text [avatarUrl]="bodyItem.avatar" [label]="bodyItem[column.id]" *ngIf="column.avatar">
                      </app-avatar-text>
                      <span *ngIf="!column.avatar && !column.contact">
                        {{bodyItem[column.id]}}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </div>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- Add filter here! -->
  <app-filter-leads (closeModal)="handleModal()" (emitFilter)="applyFilter()" [formGroup]="form" *ngIf="showFilter" (resetClick)="clear()"></app-filter-leads>

</div>
<p class="distribution__title">Distribuição por corretor</p>
<div class="custom__table__leads">
  <table class="rounded__border table__border scroll__customized">
    <div class="table__content--full-width">
      <tr class="header">
        <th *ngFor="let column of headers; let i = index"
          [ngStyle]="column.style.headerWidth ? {'width': column.style.headerWidth} : {'width': column.style.width}">
          <app-arrow-label *ngIf="column.sort" (sort)="sort($event, column)" label="column.label">
            <span>{{column.label}}</span>
          </app-arrow-label>
          <span *ngIf="!column.sort">{{column.label}}</span>
        </th>
      </tr>
      <div style="width: 100%;">
        <tbody class="body">
          <tr *ngFor="let bodyItem of data; let i = index">
            <td [ngStyle]="{'width': column.style.width}"
              (click)="column.onClick && column.onClick(bodyItem, bodyItem[column.id])"
              *ngFor="let column of headers; let i = index">
              <app-avatar-text [avatarUrl]='bodyItem.avatar' [label]="bodyItem[column.id]" *ngIf="column.avatar">
              </app-avatar-text>
              <span *ngIf="!column.avatar" [ngClass]="{'text__dotted': column.dotted}">
                {{bodyItem[column.id]}}
              </span>
            </td>
          </tr>
        </tbody>
      </div>
    </div>
  </table>
</div>
<app-edit-fac-modal *ngIf="showFacModal" [facdId]="facId" [show]="showFacModal" (closeM)="closeFacModal()" [removeGlobalScroll]="false">
</app-edit-fac-modal>